import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Trash = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="trash icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0.981995C9.44772 0.981995 9 1.42971 9 1.98199C9 2.53428 8.55228 2.98199 8 2.98199H2.5C1.67157 2.98199 1 3.65357 1 4.48199C1 5.31042 1.67157 5.98199 2.5 5.98199H21.5C22.3284 5.98199 23 5.31042 23 4.48199C23 3.65357 22.3284 2.98199 21.5 2.98199H16C15.4477 2.98199 15 2.53428 15 1.98199C15 1.42971 14.5523 0.981995 14 0.981995H10ZM21 7.98199H3L4.7922 23.2157C4.9107 24.2229 5.76433 24.982 6.7785 24.982H17.2215C18.2357 24.982 19.0893 24.2229 19.2078 23.2157L21 7.98199ZM13 11.982C13 11.4297 12.5523 10.982 12 10.982C11.4477 10.982 11 11.4297 11 11.982V20.982C11 21.5343 11.4477 21.982 12 21.982C12.5523 21.982 13 21.5343 13 20.982V11.982ZM16.5555 10.9835C17.1069 11.0142 17.5291 11.486 17.4985 12.0375L16.9985 21.0375C16.9678 21.5889 16.496 22.0111 15.9445 21.9805C15.3931 21.9498 14.9709 21.478 15.0015 20.9265L15.5015 11.9265C15.5322 11.3751 16.004 10.9529 16.5555 10.9835ZM8.49846 11.9265C8.46782 11.3751 7.99596 10.9529 7.44453 10.9835C6.89309 11.0142 6.4709 11.486 6.50154 12.0375L7.00154 21.0375C7.03217 21.5889 7.50403 22.0111 8.05547 21.9805C8.6069 21.9498 9.02909 21.478 8.99846 20.9265L8.49846 11.9265Z"
    />
  </svg>
)
